
import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const noticeConfigApi = {
  list (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/notice-config/`, {params: params})
  },
  detail (noticeConfigId, params) {
    return axios.get(`${ApiSetting.baseUrl}/api/notice-config/${noticeConfigId}/`, {params: params})
  },
  update (noticeConfigId, params) {
    return axios.put(
      `${ApiSetting.baseUrl}/api/notice-config/${noticeConfigId}/`, querystring.stringify(params))
  },
}

export default noticeConfigApi
